import { dev } from "./env";
export const FADE_CONFIG = { duration: dev ? 50 : 500 }; // ms
